import { message } from 'antd';
import { joyspacePermissionType } from '../types';
import Fetch from './request';

export interface ShareListType {
  permission: joyspacePermissionType;
  sendMessage: boolean;
  shareId: string;
  resourceId: string | undefined;
}

export const batchPermission = (shareList: ShareListType[]) => {
  return Fetch<any>({
    url: `v1/shares/batchSetPermission`,
    api: 'joyspace.share.batchSetPermission',
    method: 'PUT',
    body: JSON.stringify(shareList),
  })
    .then((res: any) => {
      const [data, err] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return false;
      }
      return data;
    })
    .catch(err => false);
};

export const batchRemove = (shareList: string[], pageId: any) => {
  return Fetch<any>({
    url: `v1/shares/batchRemoveShare`,
    api: 'joyspace.share.batchRemoveShare',
    method: 'DELETE',
    body: JSON.stringify({
      resourceId: pageId,
      shareIds: shareList,
    }),
  })
    .then((res: any) => {
      const [data, err] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return false;
      }
      return data;
    })
    .catch(err => false);
};

export const removePermission = (shareId: string) => {
  return Fetch<any>({
    url: `v1/shares/${shareId}`,
    api: 'joyspace.share.remove',
    method: 'DELETE',
  });
};

export const setPermission = (shareId: string, permission: any) => {
  return Fetch<any>({
    url: `v1/shares/${shareId}/permission`,
    api: 'joyspace.share.permission',
    method: 'PUT',
    body: JSON.stringify({ permission }),
  });
};
